import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import swal from "sweetalert";
import store from "../store";
// import moment from "moment";
import moment from "moment-timezone";

import mixpanel from "mixpanel-browser";
import { endProviderAccessSession } from "./providerAccessSession";
import { useSelector } from "react-redux";
// export const showError = (message, status, navigate = true) => {
//   if (status === 401) {
//     if (navigate) {
//       swal("Session Expired", "", "error");
//       removeCookie("token");
//       window.location.href = "/login";
//     } else {
//       swal("Oops! Something went wrong", message || "", "error");
//     }
//   } else swal("Oops! Something went wrong", message || "", "error");
// };

export const showSuccess = (message) => {
  swal("Success", message || "", "success");
};
export const showError = (message, status, navigate = true) => {
  // if (status === 401) {
  //   if (navigate) {
  //     swal("Session Expired", "", "error");
  //     removeCookie("token");
  //     window.location.href = "/login";
  //   } else {
  //     swal("Oops! Something went wrong", message || "", "error");
  //   }
  // } else
  swal("Oops! Something went wrong", message || "", "error");
};

export const showInfo = (message) => {
  swal("Info", message || "", "success");
};

// Auth cookies are session cookies: no `expires`, so closing the browser ends
// the login (OD-1503). secure/sameSite match the customer app's setCookie.
// The server-side token expiry and the inactivity logout are the backstop for
// browsers that restore session cookies on restart.
export const setCookie = (value, key) => {
  const isHttps = window.location.protocol === "https:";
  Cookies.set(key, value, {
    path: "/",
    secure: isHttps,
    sameSite: isHttps ? "strict" : "lax",
  });
};

export const getCookie = (key) => Cookies.get(key);

export const removeCookie = (key) => Cookies.remove(key, { path: "/" });

// Run once per app load, before anything reads the token: rewrites a login
// cookie set before OD-1503 with the flags above. Skypoint's cookie was
// already a session cookie, so this only adds secure/sameSite to it.
export const upgradeAuthCookiesToSession = () => {
  ["token", "skypoint_token"].forEach((key) => {
    const value = getCookie(key);
    if (value) setCookie(value, key);
  });
};

// Session-scoped localStorage keys. `theme` is deliberately excluded — it is a
// device preference, not user data.
const SESSION_STORAGE_KEYS = [
  "token",
  "roleId",
  "expireTime",
  "clock-status",
  "calendar_date",
  "selectedClient",
  "isProviderView",
  "qr_session",
  "billingservices",
  "finalservices",
  "performActionFlag",
];

// Clear every trace of the current session: auth cookies, session-scoped
// localStorage keys, and the entire Redux store. Every logout AND every login
// entry point must call this first so a previous user's session can never
// leak into the next one.
export const clearSession = () => {
  removeCookie("token");
  removeCookie("skypoint_token");
  SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  store.dispatch({ type: "RESET_STORE" });
};

// Hard redirect (not SPA navigation) is required: the page reload drops all
// in-memory state and the Socket.IO connection, whose joined rooms would
// otherwise keep delivering the previous user's real-time events.
// `endReason` is recorded on an open provider-view access session (OD-1524).
export const performLogout = (redirectTo = "/", endReason = "logged_out") => {
  endProviderAccessSession(endReason);
  clearSession();
  window.location.href = redirectTo;
};

// browser Inactive sessions expire after 30 minutes
// let inactivityTimeout;
// function resetTimer() {
//   clearTimeout(inactivityTimeout);
//   inactivityTimeout = setTimeout(logOutUser, 30 * 60 * 1000); // 30 minutes
// }
// function logOutUser() {
//   removeCookie("token");
//   mixpanel.track("Logout");
//   mixpanel.reset();
//   window.location.href = '/login';
// }
// ['mousemove', 'keydown', 'click'].forEach(event => {
//   window.addEventListener(event, resetTimer);
// });
// resetTimer();

export const formatDate = (date) => {
  // let months = [
  //   "Jan",
  //   "Feb",
  //   "Mar",
  //   "Apr",
  //   "May",
  //   "Jun",
  //   "Jul",
  //   "Aug",
  //   "Sep",
  //   "Oct",
  //   "Nov",
  //   "Dec",
  // ];

  ///hamza changes

  let months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  if (
    `${date}`.split(":")?.length === 3 &&
    `${date}`.split("-")?.length === 3
  ) {
    // const parsedDate = new Date(date);
    const parsedDate = moment(date).tz(moment.tz.guess());
    const day = parsedDate.get("date");
    const month = parsedDate.get("month");
    const year = parsedDate.get("year");
    // return `${months[month]} ${day}, ${year}`;

    //hamza changes

    return `${months[month]}-${day}-${year}`;
    //  return `${day}-${months[month]}-${year}`;
  } else {
    return date;
  }
};

export const formatTime = (date) => {
  if (
    `${date}`.split(":")?.length === 3 &&
    `${date}`.split("-")?.length === 3
  ) {
    return moment(date)?.format("hh:mm a");
  } else {
    return date;
  }
};

export const dateFormat2 = (inputDate) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const dateObject = new Date(inputDate);
  const day = dateObject.getDate();
  const monthIndex = dateObject.getMonth();

  const formattedDate = `${months[monthIndex]} ${day
    .toString()
    .padStart(2, "0")}`;

  return formattedDate;
};

export const isSubscriptionExpired = () => {
  return store?.getState()?.profile?.profile?.subscriptionExpired;
};

export const isSignatureActivated = () => {
  return store?.getState()?.profile?.profile?.user?.signatureActive;
};

export function formatFileSize(bytes) {
  const units = ["Bytes", "KB", "MB", "GB"];
  let index = 0;
  while (bytes >= 1024 && index < units.length - 1) {
    bytes = bytes / 1024;
    index++;
  }
  return `${bytes.toFixed(2)} ${units[index]}`;
}

export const states = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const defaultImage = "./../images/personal2.png";

export const getOptions = (
  optionType,
  custom,
  fieldName,
  withDeleted = false
) => {
  // if(optionType === "Other") console.log("custom of other :", fieldName ,custom)
  let othersArray = [];
  if (custom && Array.isArray(custom)) {
    var classField = custom?.find(
      // (item) => item?.field === fieldName || item?.options === "Other"
      (item) => item?.field === fieldName
    );
    if (classField) {
      othersArray = classField?.others
        ? classField?.others?.split(",")?.map((item) => item?.trim())
        : [];
    }
  }

  let multipleChoice = [];
  if (custom && Array.isArray(custom)) {
    let classField = custom?.find(
      (item) => item?.options === "multipleOptions" && item?.field === fieldName
    );
    multipleChoice = classField?.multipleChoice;
  }

  let singleChoice = [];
  if (custom && Array.isArray(custom)) {
    let classField = custom?.find(
      (item) => item?.options === "singleOptions" && item?.field === fieldName
    );
    singleChoice = classField?.singleChoice;
  }

  let dropdownChoice = [];
  if (custom && Array.isArray(custom)) {
    let classField = custom?.find(
      (item) => item?.options === "dropdownOptions" && item?.field === fieldName
    );
    dropdownChoice = classField?.dropdownChoice;
  }
  const allbillingprovider = store?.getState()?.billingprovider;

  let { allFacilities, allDeletedFacilities, allFacilityTypes } =
    store?.getState()?.facility;
  let { allPatients } = store?.getState()?.patient;
  // let { allAssignPatients } = store?.getState()?.patient;
  let { staff, allStaff } = store?.getState()?.staff;

  // if (otherOptions) othersArray = otherOptions;

  const returnFacilitiesArray = () => {
    if (withDeleted === true) {
      if (allDeletedFacilities?.facilities) {
        return allDeletedFacilities?.facilities?.map((value) => ({
          value: value?.id,
          label: value?.name,
        }));
      } else {
        return [];
      }
    } else {
      if (allFacilities?.facilities) {
        return allFacilities?.facilities?.map((value) => ({
          value: value?.id,
          label: value?.name,
        }));
      } else {
        return [];
      }
    }
  };

  let obj = {
    facilities: returnFacilitiesArray(),
    clients: allPatients
      ? allPatients?.map((value) => ({
          value: value?.id,
          label: value?.name,
          disabled: !value?.active,
        }))
      : [],
    staff: staff?.staffs
      ? staff?.staffs?.map((value) => ({
          value: value?.id,
          label:
            value?.type === "staff" ? value?.name : `${value?.name} (admin)`,
        }))
      : [],
    "staff all": allStaff
      ? allStaff?.map((value) => ({
          value: value?.id,
          label:
            value?.type === "staff" ? value?.name : `${value?.name} (admin)`,
        }))
      : [],
    "facility types": allFacilityTypes?.ftypes
      ? allFacilityTypes?.ftypes?.map((value) => ({
          value: value?.id,
          label: value?.name,
        }))
      : [],

    other: othersArray
      ? othersArray?.map((value) => ({
          value: value,
          label: value,
        }))
      : [],
    "multiple choices":
      multipleChoice?.length > 0
        ? multipleChoice?.map((value) => ({
            value: value,
            label: value,
          }))
        : [],
    "single choice":
      singleChoice?.length > 0
        ? singleChoice?.map((value) => ({
            value: value,
            label: value,
          }))
        : [],
    dropdown:
      dropdownChoice?.length > 0
        ? dropdownChoice?.map((value) => ({
            value: value,
            label: value,
          }))
        : [],
    "level of need": [
      {
        value: 'LON 1 - Intermittent',
        label: 'LON 1 - Intermittent',
      },
      {
        value: 'LON 5 - Limited',
        label: 'LON 5 - Limited',
      },
      {
        value: 'LON 8 - Extensive',
        label: 'LON 8 - Extensive',
      },
      {
        value: 'LON 6 - Pervasive',
        label: 'LON 6 - Pervasive',
      },
      {
        value: 'LON 9 - Pervasive+',
        label: 'LON 9 - Pervasive+',
      },
    ]
  };

  return obj[optionType?.toLowerCase()];
};

let secretKey = "ogiso-life-secret";
export let noteType_Client = "Client Name";
export let noteType_Client_Options = "Clients";

export const decrypt = (cipher, parse = true) => {
  try {
    var bytes = CryptoJS.AES.decrypt(cipher, secretKey);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    // let secretKey = process.env.REACT_APP_ENCRYPT_SECRET;
    if (parse) return JSON.parse(originalText);
    else return originalText;
  } catch (e) {
    return originalText;
  }
};

export const encrypt = (data) => {
  // let secretKey = process.env.REACT_APP_ENCRYPT_SECRET;
  var ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  return ciphertext;
};

export const sortByDateAndTime = (arr) => {
  const newArr = arr?.length > 0 ? [...arr] : [];

  newArr?.sort((a, b) => {
    const dateA = moment(a?.date);
    const timeA = moment(a?.timeSlot ? a?.timeSlot : a?.date, "hh:mm A");
    const combinedDateTimeA = moment({
      year: dateA.year(),
      month: dateA.month(),
      date: dateA.date(),
      hour: timeA.hours(),
      minute: timeA.minutes(),
    });

    const dateB = moment(b?.date);
    const timeB = moment(b?.timeSlot ? b?.timeSlot : b?.date, "hh:mm A");
    const combinedDateTimeB = moment({
      year: dateB.year(),
      month: dateB.month(),
      date: dateB.date(),
      hour: timeB.hours(),
      minute: timeB.minutes(),
    });

    return combinedDateTimeB - combinedDateTimeA;
  });

  return newArr;
};

export const getPriorityColor = (date, data) => {
  // Missed #eb7a74
  // Unable to Take #feff80
  // Refused #c7daf5
  // PRN #a03399
  // Taken #4fa80d
  // Out of Medication #000
  // upcoming #979797
  const _dateFormat = "YYYY-MM-DD";
  const types = data
    ?.filter(
      (x) =>
        moment(date).format(_dateFormat) === moment(x?.date).format(_dateFormat)
    )
    ?.map((v) => v?.medicationType);

  return checkType(types);
};

export const getDailyPriorityColor = (data) => {
  const types = data?.map((v) => v?.medicationType);
  return checkType(types);
};

const checkType = (types) => {
  if (types?.includes("Missed")) {
    return "#eb7a74";
  } else if (types?.includes("Unable to Take")) {
    return "#feff80";
  } else if (types?.includes("Refused")) {
    return "#c7daf5";
  } else if (types?.includes("PRN")) {
    return "#a03399";
  } else if (types?.includes("Taken")) {
    return "#4fa80d";
  } else if (types?.includes("Out of Medication")) {
    return "#000";
  } else if (types?.includes("upcoming")) {
    return "#979797";
  } else {
    return "#fff";
  }
};

export const firstLetterCap = (str) => {
  return str ? str?.[0].toUpperCase() + str?.slice(1) : str;
};

export function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
}

// /**
//  * Returns a list of all world timezones,
//  * formatted with their current GMT offset and zone name.
//  *
//  * @returns {Array<{ label: string, value: string }>}
//  */
// export function getAllTimezones() {
//   return moment.tz.names().map((zone) => {
//     const offset = moment.tz(zone).utcOffset(); // offset in minutes
//     const sign = offset >= 0 ? "+" : "-";
//     const hours = Math.floor(Math.abs(offset) / 60);
//     const minutes = Math.abs(offset) % 60;
//     const formattedOffset = `GMT${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

//     return {
//       label: `${zone} (${formattedOffset})`,
//       value: zone,
//     };
//   });
// }

// export function getAllTimezones() {
//   return moment.tz.names();
// }

export function getAllTimezonesWithAbbr() {
  const timezones = moment.tz.names();

  return timezones.map((tz) => {
    const now = moment.tz(tz);
    const offset = now.utcOffset();
    const offsetHours = Math.floor(offset / 60);
    const offsetMinutes = offset % 60;
    const sign = offset >= 0 ? "+" : "-";
    const paddedHours = String(Math.abs(offsetHours)).padStart(2, "0");
    const paddedMinutes = String(Math.abs(offsetMinutes)).padStart(2, "0");
    const gmtOffset = `(GMT${sign}${paddedHours}:${paddedMinutes})`;
    const abbr = now.zoneAbbr(); // returns PST, MST, etc.

    return {
      label: `${gmtOffset} ${tz} (${abbr})`,
      value: tz,
    };
  });
}

export const getAbbreviationFromName = (stateName) => {
  const state = usStates?.find((s) => s?.name === stateName);
  return state ? state?.abbreviation : "";
};

export const getNameFromAbbreviation = (stateAbbrev) => {
  const state = usStates?.find((s) => s?.abbreviation === stateAbbrev);
  return state ? state?.name : "";
};

// export const obfuscateEmail = (email) => {
//   if (!email) return "No email found";
//   const [name, domain] = email.split("@");
//   const maskedName = name.length > 2 ? name.slice(0, 2) + "***" : "***";
//   return `${maskedName}@${domain}`;
// };

export const obfuscateEmail = (email) => {
  if (!email) return "No email found"

  const [name, domain] = email.split("@");

  // Keep first 2 and last 2 characters, mask the middle
  let maskedName;
  if (name.length <= 4) {
    // For very short names, mask everything except first letter
    maskedName = name[0] + "***";
  } else {
    const firstTwo = name.slice(0, 2);
    const lastTwo = name.slice(-2);
    const maskedCount = name.length - 4;
    maskedName = `${firstTwo}${"*".repeat(maskedCount)}${lastTwo}`;
  }

  return `${maskedName}@${domain}`;
};

export const obfuscatePhone = (phone) => {
  if (!phone) return "No phone found";

  // Extract digits only
  const digits = phone.replace(/\D/g, "");

  if (digits.length <= 4) return digits; // too short to mask

  // Detect country code (1–3 digits)
  // If original phone starts with "+", assume the first 1–3 digits are country code
  let countryCode = "";
  let mainNumber = digits;

  if (phone.trim().startsWith("+")) {
    // Country code is typically 1-3 digits
    countryCode = digits.slice(0, digits.length - 10); // Assume last 10 digits are national number
    if (countryCode.length === 0) {
      countryCode = digits.slice(0, 1); // fallback minimal CC
    }
    mainNumber = digits.slice(countryCode.length);
  }

  // Now mask mainNumber
  if (mainNumber.length <= 5) {
    // Not enough digits to format normally
    return `+${countryCode}${mainNumber}`;
  }

  const firstThree = mainNumber.slice(0, 3);
  const lastTwo = mainNumber.slice(-2);
  const masked = `${firstThree}${"*".repeat(mainNumber.length - 5)}${lastTwo}`;

  return countryCode
    ? `+${countryCode}${masked}`
    : masked;
};


// export const obfuscatePhone = (phone) => {
//   if (!phone) return "No phone found";

//   // Remove non-digit characters for masking logic
//   const digitsOnly = phone.replace(/\D/g, "");

//   // If very short number
//   if (digitsOnly.length <= 4) {
//     return `${digitsOnly}`;
//   }

//   const firstThree = digitsOnly.slice(0, 3);
//   const lastTwo = digitsOnly.slice(-2);
//   const maskedCount = digitsOnly.length - 5; // total - (first3 + last2)

//   const masked = `${firstThree}${"*".repeat(maskedCount)}${lastTwo}`;

//   return `${masked}`;
// };



// export const obfuscatePhone = (phone) => {
//   if (!phone) return "No phone found";
//   const lastDigits = phone.slice(-4);
//   return phone.length > 4 ? `*********${lastDigits}` : phone;
// };

export const usStates = [
  { abbreviation: "AL", name: "Alabama" },
  { abbreviation: "AK", name: "Alaska" },
  { abbreviation: "AZ", name: "Arizona" },
  { abbreviation: "AR", name: "Arkansas" },
  { abbreviation: "CA", name: "California" },
  { abbreviation: "CO", name: "Colorado" },
  { abbreviation: "CT", name: "Connecticut" },
  { abbreviation: "DE", name: "Delaware" },
  { abbreviation: "FL", name: "Florida" },
  { abbreviation: "GA", name: "Georgia" },
  { abbreviation: "HI", name: "Hawaii" },
  { abbreviation: "ID", name: "Idaho" },
  { abbreviation: "IL", name: "Illinois" },
  { abbreviation: "IN", name: "Indiana" },
  { abbreviation: "IA", name: "Iowa" },
  { abbreviation: "KS", name: "Kansas" },
  { abbreviation: "KY", name: "Kentucky" },
  { abbreviation: "LA", name: "Louisiana" },
  { abbreviation: "ME", name: "Maine" },
  { abbreviation: "MD", name: "Maryland" },
  { abbreviation: "MA", name: "Massachusetts" },
  { abbreviation: "MI", name: "Michigan" },
  { abbreviation: "MN", name: "Minnesota" },
  { abbreviation: "MS", name: "Mississippi" },
  { abbreviation: "MO", name: "Missouri" },
  { abbreviation: "MT", name: "Montana" },
  { abbreviation: "NE", name: "Nebraska" },
  { abbreviation: "NV", name: "Nevada" },
  { abbreviation: "NH", name: "New Hampshire" },
  { abbreviation: "NJ", name: "New Jersey" },
  { abbreviation: "NM", name: "New Mexico" },
  { abbreviation: "NY", name: "New York" },
  { abbreviation: "NC", name: "North Carolina" },
  { abbreviation: "ND", name: "North Dakota" },
  { abbreviation: "OH", name: "Ohio" },
  { abbreviation: "OK", name: "Oklahoma" },
  { abbreviation: "OR", name: "Oregon" },
  { abbreviation: "PA", name: "Pennsylvania" },
  { abbreviation: "RI", name: "Rhode Island" },
  { abbreviation: "SC", name: "South Carolina" },
  { abbreviation: "SD", name: "South Dakota" },
  { abbreviation: "TN", name: "Tennessee" },
  { abbreviation: "TX", name: "Texas" },
  { abbreviation: "UT", name: "Utah" },
  { abbreviation: "VT", name: "Vermont" },
  { abbreviation: "VA", name: "Virginia" },
  { abbreviation: "WA", name: "Washington" },
  { abbreviation: "WV", name: "West Virginia" },
  { abbreviation: "WI", name: "Wisconsin" },
  { abbreviation: "WY", name: "Wyoming" },
];

export const initialAdminPermissions = {
    aiAccess: true,
    staff: true,
    task: true,
    note: true,
    medication: true,
    report: true,
    facility: true,
    invoice: true,
    // billing: true,
    dashboardCompliance: true,
    dashboardOperational: true,
    dashboardProviderBreakdown: true,
    dashboardBusinessMetrics: true,
  };


export const initialStaffPermissions = {
    aiAccess: true,
    task: true,
    note: true,
    medication: true,
    report: true,
    dashboardCompliance: true,
    dashboardOperational: true,
    dashboardProviderBreakdown: true,
    dashboardBusinessMetrics: false,
  };

// Lower-case extension of a file URL or name, ignoring any query string (a
// signed link, OD-1468) or fragment — "pdf" for ".../a.pdf?X-Amz-Signature=…".
export const fileExtension = (url) =>
  String(url || "").split("#")[0].split("?")[0].split("/").pop().split(".").pop().toLowerCase();
